import React from 'react';

import GlanceSlideshow from '@components/pages/EventsLanding/GlanceSlideshow';

const EventCluster = () => {
  return (
    <section className="lg:pt-112">
      <div className="mx-auto flex flex-col items-center">
        <h2 className="m-0 text-center font-suisse-works text-headline-sm text-primary-black sm:text-headline-lg">
          The Information Events
        </h2>
        <p className="m-0 mt-24 text-center font-suisse-neue text-body-lg text-primary-black">
          The Information’s events—virtual and live—deliver insider perspectives you can’t get
          elsewhere. Subscribers get free or discounted access.
        </p>
        <p className="m-0 mt-24 text-center font-suisse-neue text-body-lg text-primary-black">
          Financing the AI Revolution | Women in Tech, Media and Finance | Webinars
        </p>
      </div>
      <div className="mt-32">
        <div className="relative mx-auto aspect-[16/9] w-full overflow-hidden *:*:aspect-[16/9] sm:max-w-[600px] sm:*:*:!h-[350px] md:h-[440px] md:max-w-[750px] md:*:*:!h-[440px] lg:h-auto lg:*:*:!h-auto">
          <GlanceSlideshow />
        </div>
      </div>
    </section>
  );
};

export default EventCluster;
